import { Col, Row } from "antd";
import { Trans, useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowDown, faArrowUp } from "@fortawesome/free-solid-svg-icons";
import { ReactComponent as FollowersIcon } from "shared/assets/images/followers-icon.svg";
import { ReactComponent as RocketIcon } from "shared/assets/images/rocket-icon.svg";
import moment from "moment";

interface CareerCatalogAnalysisProps {
  phonographicCatalogAnalysis: any;
}

const CareerCatalogAnalysisMobile: React.FC<CareerCatalogAnalysisProps> = (
  props
) => {
  const { phonographicCatalogAnalysis } = props;
  const formatDate = (date: string) => {
    const momentDate = moment(date);
    return momentDate.isValid() ? momentDate.format("DD/MM/YYYY") : "-";
  };
  const { t } = useTranslation("radar");
  const formatNumber = (number: number) =>
    Number.isFinite(number) ? number.toFixed(1) : "-";

  return (
    <div className="analysis-of-phonographic-catalog">
      <h1 className="texto-colorido title">
        {t("pages.CareerDiagnose.phonographicCatalogTitle")}
      </h1>
      <p style={{ textAlign: "justify", fontSize: 14 }}>
        <Trans
          i18nKey={`pages.CareerDiagnose.phonographicCatalogText`}
          ns="radar"
        />
      </p>
      <Row gutter={[32, 32]}>
        <Col xs={12}>
          <div
            className="card"
            style={{ height: 150, fontSize: 10, backgroundColor: "#000" }}
          >
            <RocketIcon className="main-icon" />
            {t("pages.CareerDiagnose.releaseFrequencyMessage")}
            <span style={{ color: "#B692F6" }}>
              {t("pages.CareerDiagnose.manyDays", {
                days: phonographicCatalogAnalysis?.releaseFreqDays,
              })}
            </span>
            <span
              className={`${
                phonographicCatalogAnalysis?.releaseIsUnderAverage
                  ? "red"
                  : "green"
              } card-text`}
            >
              {phonographicCatalogAnalysis?.releaseIsUnderAverage ? (
                <>
                  <FontAwesomeIcon icon={faArrowDown} />
                  {` ${Math.abs(
                    phonographicCatalogAnalysis?.releasePercentage
                  )}%`}
                </>
              ) : (
                <>
                  <FontAwesomeIcon icon={faArrowUp} />
                  {` ${Math.abs(
                    phonographicCatalogAnalysis?.releasePercentage
                  )}%`}
                </>
              )}
            </span>
            <span className="font-light">
              {phonographicCatalogAnalysis?.releaseIsUnderAverage
                ? t("pages.ArtistProfile.belowAverage")
                : t("pages.ArtistProfile.aboveAverage")}
            </span>
          </div>
        </Col>
        <Col xs={12}>
          <div
            className="card"
            style={{ height: 150, fontSize: 10, backgroundColor: "#000" }}
          >
            <RocketIcon className="main-icon" />
            {t("pages.CareerDiagnose.releaseFrequency12MonthsMessage")}
            <span style={{ color: "#B692F6" }}>
              {t("pages.CareerDiagnose.releaseFrequency12Months", {
                releases:
                  phonographicCatalogAnalysis?.releasesLast12MonthsTotal,
              })}
            </span>
            <span
              className={`${
                phonographicCatalogAnalysis?.releaseLast12MonthsIsUnderAverage
                  ? "red"
                  : "green"
              } card-text`}
            >
              {phonographicCatalogAnalysis?.releaseLast12MonthsIsUnderAverage ? (
                <>
                  <FontAwesomeIcon icon={faArrowDown} />
                  {` ${Math.abs(
                    phonographicCatalogAnalysis?.releaseLast12MonthsPercentage
                  )}%`}
                </>
              ) : (
                <>
                  <FontAwesomeIcon icon={faArrowUp} />
                  {` ${Math.abs(
                    phonographicCatalogAnalysis?.releaseLast12MonthsPercentage
                  )}%`}
                </>
              )}
            </span>
            <span className="font-light">
              {phonographicCatalogAnalysis?.releaseLast12MonthsIsUnderAverage
                ? t("pages.ArtistProfile.belowAverage")
                : t("pages.ArtistProfile.aboveAverage")}
            </span>
          </div>
        </Col>

        <Col xs={12}>
          <div
            className="card"
            style={{ height: 150, fontSize: 10, backgroundColor: "#000" }}
          >
            <FollowersIcon className="main-icon" />
            <Trans
              i18nKey={`pages.CareerDiagnose.popularityFeatVsSolo`}
              ns="radar"
            />
            <div
              style={{
                display: "flex",
                justifyContent: "space-around",
                width: "100%",
                // fontSize: 32,
              }}
            >
              <span>
                {formatNumber(phonographicCatalogAnalysis?.popularityFeat)}
              </span>
              <span>
                {formatNumber(phonographicCatalogAnalysis?.popularitySolo)}
              </span>
            </div>
            <span style={{ color: "#B692F6" }}>
              {
                phonographicCatalogAnalysis?.percentageBetweenPopularityFeatAndPopularitySolo
              }
              %
            </span>
            <span className="font-light" style={{ fontSize: 12 }}>
              {t("pages.CareerDiagnose.differencePercentage")}
            </span>
          </div>
        </Col>
        <Col xs={12}>
          <div
            className="card"
            style={{ height: 150, fontSize: 10, backgroundColor: "#000" }}
          >
            <FollowersIcon className="main-icon" />
            <Trans
              i18nKey={`pages.CareerDiagnose.popularitySingleVsAlbum`}
              ns="radar"
            />
            <div
              style={{
                display: "flex",
                justifyContent: "space-around",
                width: "100%",
                // fontSize: 32,
              }}
            >
              <span>
                {formatNumber(phonographicCatalogAnalysis?.popularitySingle)}
              </span>
              <span>
                {formatNumber(phonographicCatalogAnalysis?.popularityAlbum)}
              </span>
            </div>
            <span style={{ color: "#B692F6" }}>
              {
                phonographicCatalogAnalysis?.percentageBetweenPopularitySingleAndPopularityAlbum
              }
              %
            </span>
            <span className="font-light" style={{ fontSize: 12 }}>
              {t("pages.CareerDiagnose.differencePercentage")}
            </span>
          </div>
        </Col>
        <Col xs={24}>
          <div
            style={{
              display: "flex",
              gap: 12,
              marginTop: 32,
              flexDirection: "row",
              backgroundColor: "#000",
              padding: "24px 0",
            }}
            className="card"
          >
            <div className="info-fact-container">
              <h3 className="info-fact-label">
                {t("pages.CareerDiagnose.releases")}
              </h3>
              <span
                style={{
                  display: "block",
                  fontSize: 10,
                  textTransform: "none",
                }}
              >
                {t("pages.CareerDiagnose.releasesDisclaimer")}
              </span>
            </div>
            <div className="info-fact-container">
              <h3 className="info-fact-label">
                {t("pages.CareerDiagnose.firstRelease")}
              </h3>
              <span className="info-fact-value">
                {formatDate(phonographicCatalogAnalysis?.firstRelease)}
              </span>
            </div>
            <div className="info-fact-container">
              <h3 className="info-fact-label">
                {t("pages.CareerDiagnose.lastRelease")}
              </h3>
              <span className="info-fact-value">
                {formatDate(phonographicCatalogAnalysis?.lastRelease)}
              </span>
            </div>
            <div className="info-fact-container">
              <h3 className="info-fact-label">
                {t("pages.CareerDiagnose.totalRelease")}
              </h3>
              <span className="info-fact-value">
                {phonographicCatalogAnalysis?.totalReleases || "-"}
              </span>
            </div>
          </div>
        </Col>
        <Col xs={24}>
          <div
            style={{
              display: "flex",
              gap: 12,
              marginTop: 32,
              flexDirection: "row",
              backgroundColor: "#000",
              padding: "24px 0",
            }}
            className="card"
          >
            <div className="info-fact-container">
              <h3 className="info-fact-label">
                {t("pages.CareerDiagnose.collabs")}
              </h3>
              <span
                style={{
                  fontSize: 10,
                  textTransform: "none",
                }}
              >
                {t("pages.CareerDiagnose.collabsDisclaimer")}
              </span>
            </div>
            <div className="info-fact-container">
              <h3 className="info-fact-label">
                {t("pages.CareerDiagnose.main")}
              </h3>
              <span className="info-fact-value">
                {phonographicCatalogAnalysis?.protagonistCollab || "-"}
              </span>
            </div>
            <div className="info-fact-container">
              <h3 className="info-fact-label">
                {t("pages.CareerDiagnose.guest")}
              </h3>
              <span className="info-fact-value">
                {phonographicCatalogAnalysis?.invitedCollab || "-"}
              </span>
            </div>
            <div className="info-fact-container">
              <h3 className="info-fact-label">
                {t("pages.CareerDiagnose.totalRelease")}
              </h3>
              <span className="info-fact-value">
                {phonographicCatalogAnalysis?.totalCollab || "-"}
              </span>
            </div>
          </div>
        </Col>
      </Row>
      <div
        style={{
          display: "none",
          justifyContent: "center",
          gap: 96,
          margin: "64px 0",
        }}
      >
        <div style={{ textAlign: "center", visibility: "hidden" }}>
          <h3 className="info-fact-label">
            {t("pages.CareerDiagnose.totalColaboration")}
          </h3>
          <span className="info-fact-value">
            {phonographicCatalogAnalysis?.totalCollab}
          </span>
        </div>
      </div>
    </div>
  );
};

export default CareerCatalogAnalysisMobile;
